import { Currency } from "@redotech/money/currencies";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const shippingDiscountSchema = z
  .object({
    amount: z
      .object({ currency: z.enum(Currency), value: z.string() })
      .optional(),
    percentage: z.string().optional(),
  })
  .optional();

export const updateCheckoutExperience = {
  name: "updateCheckoutExperience" as const,
  input: z.object({
    checkoutExperienceId: zExt.objectId(),
    name: z.string().optional(),
    shippingDiscount: shippingDiscountSchema.optional(),
  }),
  output: z.null(),
};
